import { render, staticRenderFns } from "./haokaOrder copy.vue?vue&type=template&id=b176bcf4&scoped=true&"
import script from "./haokaOrder copy.vue?vue&type=script&lang=js&"
export * from "./haokaOrder copy.vue?vue&type=script&lang=js&"
import style0 from "./haokaOrder copy.vue?vue&type=style&index=0&id=b176bcf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b176bcf4",
  null
  
)

export default component.exports